
/**
 * Alert Priorities
 */
export enum AlertPriority {
  Low,
  High
}

/**
 * AirportAlert model
 */
export class AirportAlert {
  /**
   * Numeric identifier that uniquely identifies this alert in the database
   */
  alertId: number;

  /**
   * Numeric identifier that relates this alert to a source in the database
   */
  sourceId: number;

  /**
   * Alert code
   */
  code: string;

  /**
   * Alert priority
   */
  priority: AlertPriority;

  /**
   * Alert Create Date
   */
  createDate: Date;

  /**
   * * Alert Effective Date
   */
  effectiveDate: Date;

  /**
   * Alert Expirate Date
   */
  expirationDate: Date;

  /**
   * Alert Title
   */
  title: string;

  /**
   * Alert Description
   */
  description: string;

  /**
   * Alert Website
   */
  website: string;

  /**
   * Parses an alert as returned by the API into an instance of the Alert class
   */
  static parse(data: any): AirportAlert {
    return Object.assign(new AirportAlert(), {
      alertId: data.alertId,
      sourceId: data.sourceId,
      code: data.code || null,
      priority: this.parseAlertPriority(data.priority),
      createDate: data.createDate ? new Date(data.createDate) : null,
      effectiveDate: data.effectiveDate ? new Date(data.effectiveDate) : null,
      expirationDate: data.expirationDate ? new Date(data.expirationDate) : null,
      title: data.title || null,
      description: data.description || null,
      website: data.website || null
    });
  }

  /**
   * Parses alert priority from string
   * @param priority {string} alert priority as returned by API
   * @return {AlertPriority} Parsed alert priority
   */
  static parseAlertPriority(priority: string): AlertPriority {
    switch (priority) {
      case 'low':
        return AlertPriority.Low;
      case 'high':
        return AlertPriority.High;
      default:
        return null;
    }
  }

  /**
   * Formats alert priority for display
   * @param priority {AlertPriority} Alert priority
   * @return {string} Formatted alert priority
   */
  static formatAlertPriority(priority: AlertPriority): string {
    switch (priority) {
      case AlertPriority.Low:
        return 'Low';
      case AlertPriority.High:
        return 'High';
      default:
        return null;
    }
  }
}

